'use strict';

var React = require('react');

const SvgCa = ({ title, titleId, ...props }) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId }, props),
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z", fill: "#F0F0F0" }),
    React.createElement("path", { d: "M24 12a12 12 0 0 0-6.783-10.81V22.81A12 12 0 0 0 24 11.999ZM0 12a12 12 0 0 0 6.783 10.809V1.19A12 12 0 0 0 0 12ZM14.087 13.565l2.087-1.043L15.131 12v-1.044L13.043 12l1.044-2.087h-1.043L12 8.348l-1.043 1.565H9.913L10.957 12 8.87 10.956V12l-1.044.521 2.087 1.044-.522 1.043h2.087v1.566h1.044v-1.566h2.087l-.522-1.043Z", fill: "#D80027" })));

module.exports = SvgCa;
